let questionss = document.querySelectorAll(".questionss");

// Open the first FAQ by default
if (questionss.length > 0) {
  const firstQuestione = questionss[0];
  firstQuestione.classList.add("active");
  const firstAnswer = firstQuestione.nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
}

questionss.forEach((questioness) => {
  questioness.addEventListener("click", (event) => {
    const active = document.querySelector(".questionss.active");
    if (active && active !== questioness) {
      active.classList.remove("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    questioness.classList.toggle("active");
    const answer = questioness.nextElementSibling;
    if (questioness.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  });
});
